import styled from 'styled-components';
import { Box, Widget as CoreWidget } from '@scope/scope-one-ui/core';
import { COLORS } from '@scope/scope-one-ui/theme';

export const Widget = styled(CoreWidget)`
  border: none;
`;

export const Grid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const Cell = styled(Box)`
  &:not(:nth-child(3n)) {
    border-right: 1px solid ${COLORS.border.main};
  }
`;

export const ChartTitle = styled(Box)`
  border-top: 1px solid ${COLORS.border.main};
`;
